import { IMG, FLAGS } from "./shared";

const fr = {
  langName: "FR",
  nav: {
    brand: "Barlow Consultants",
    brandSub: "SL · LUXEMBOURG",
    links: [
      { label: "Dépôt à terme", href: "#konditionen" },
      { label: "Sécurité", href: "#sicherheit" },
      { label: "Gestion de patrimoine", href: "#vermoegen" },
      { label: "Conseil", href: "#beratung" },
      { label: "Équipe", href: "#team" },
      { label: "Calculateur d'intérêts", href: "#rechner" },
    ],
  },
  ui: {
    login: "Se connecter",
    openAccount: "Ouvrir un compte",
    portal: "Espace client",
    invest: "Investir",
    ratePa: "Taux annuel",
  },
  hero: {
    eyebrow: "Dépôts à terme privés & entreprises · Luxembourg",
    titlePre: "Un dépôt à terme sûr, au",
    titleAccent: "rendement",
    titlePost: "prévisible.",
    text: "Ouvrez votre compte de dépôt à terme chez Barlow Consultants SL – pour les particuliers et les entreprises (dépôt à terme entreprise). Faites travailler votre capital à des taux fixes attractifs – de façon transparente, sûre et entièrement digitale.",
    network: "Accès à plus de 50 banques européennes – ainsi qu'aux principales banques du Royaume-Uni.",
    badge1: "conseil patrimonial personnel inclus",
    badge2: "Doublement sécurisé · Garantie des dépôts + compte fiduciaire",
    btnOpen: "Ouvrir un compte",
    btnConditions: "Voir les conditions",
    btnAdvice: "Découvrir le conseil",
    floatGuarantee: "Vos dépôts sont légalement protégés jusqu'à 100 000 € par client et par banque.",
    floatRateLabel: "Intérêts fixes p.a.",
    image: IMG.hero,
    stats: [
      { icon: "Landmark", label: "Conservé auprès d'une banque partenaire réglementée" },
      { icon: "TrendingUp", label: "Intérêts fixes jusqu'à 4,25 %" },
      { icon: "CalendarClock", label: "Durées de 6 à 60 mois" },
    ],
  },
  network: {
    eyebrow: "Notre réseau bancaire",
    title: "Un solide réseau de banques européennes",
    text: "Nous collaborons avec plus de 50 banques en Europe et offrons en complément l'accès à des banques de premier plan sélectionnées au Royaume-Uni.",
    overlay1: "banques européennes",
    overlay2: "+ grandes banques britanniques",
    btnDiscover: "Découvrir les offres",
    btnCompare: "Comparer les offres",
    image: IMG.network,
    cards: [
      { icon: "Globe", title: "50+ banques européennes", text: "Accès à un vaste réseau de banques de différents pays européens." },
      { icon: "Building2", title: "Banques britanniques en plus", text: "Nous collaborons en complément avec des banques de premier plan sélectionnées au Royaume-Uni." },
      { icon: "Layers", title: "De nombreuses offres – une vue d'ensemble", text: "Notre plateforme permet aux intéressés de comparer facilement différentes offres de dépôt à terme." },
    ],
    flagsLabel: "Présents dans toute l'Europe et au Royaume-Uni",
    flags: FLAGS,
  },
  conditions: {
    title: "Conditions du dépôt à terme",
    text: "Des taux fixes pour toute la durée. Aucun risque de marché, une prévisibilité totale.",
    invest: "Investir",
    ratePa: "Taux annuel",
    rows: [
      { term: "6 mois", months: 6, rate: 2.8 },
      { term: "12 mois", months: 12, rate: 3.3 },
      { term: "24 mois", months: 24, rate: 3.6 },
      { term: "36 mois", months: 36, rate: 3.9 },
      { term: "60 mois", months: 60, rate: 4.25 },
    ],
  },
  security: {
    eyebrow: "Double sécurité",
    title: "Votre capital – protégé deux fois",
    text: "Vos dépôts sont protégés deux fois : par la garantie légale européenne des dépôts et, en complément, par leur conservation sur un compte fiduciaire.",
    layers: [
      {
        level: "Niveau 1", badge: "jusqu'à 100 000 €", badgeSub: "protégé par déposant",
        title: "Garantie légale des dépôts",
        text: "Les fonds conservés auprès d'une banque partenaire réglementée au Luxembourg relèvent du système légal de garantie des dépôts luxembourgeois (FGDL – Fonds de garantie des dépôts Luxembourg). Conformément à la directive UE 2014/49/UE, les dépôts sont protégés jusqu'à 100 000 € par déposant et par établissement.",
        note: "Conservé auprès d'une banque partenaire réglementée au Luxembourg · Protégé conformément à la directive UE 2014/49/UE",
        link: "En savoir plus sur la garantie des dépôts",
      },
      {
        level: "Niveau 2", badge: "Compte fiduciaire", badgeSub: "protection supplémentaire",
        title: "Protection fiduciaire supplémentaire",
        text: "En complément de la garantie légale des dépôts, vos avoirs sont gérés à titre fiduciaire sur un compte fiduciaire selon des règles de conservation claires.",
        bullets: [
          "Gestion fiduciaire selon des règles de conservation claires",
          "Un niveau de protection supplémentaire au-delà de la garantie des dépôts",
        ],
      },
    ],
  },
  whyUs: {
    title: "Pourquoi Barlow Consultants",
    items: [
      { icon: "ShieldCheck", title: "Sécurité du capital", text: "Vos dépôts sont conservés auprès d'une banque partenaire réglementée au Luxembourg." },
      { icon: "Percent", title: "Rendement fixe", text: "Le taux d'intérêt est fixé à la signature – pour toute la durée." },
      { icon: "Eye", title: "Transparence totale", text: "Un aperçu à tout moment de votre solde, de vos placements et des prévisions d'intérêts dans votre espace." },
      { icon: "MonitorSmartphone", title: "Ouverture digitale", text: "Ouvrez votre compte en ligne en quelques minutes – sans aucune paperasse." },
    ],
  },
  wealth: {
    eyebrow: "Gestion de patrimoine privée · Luxembourg",
    title: "Plus qu'un dépôt à terme – votre gestion de patrimoine privée.",
    text: "Barlow Consultants SL n'est pas seulement votre partenaire pour le dépôt à terme, mais aussi pour la gestion professionnelle de votre patrimoine. Nous élaborons une stratégie sur mesure et vous accompagnons sur le long terme avec discrétion et clairvoyance.",
    image: IMG.wealth,
    cta: "Demander un conseil",
    items: [
      { icon: "Target", title: "Stratégie de placement individuelle", text: "Un portefeuille aligné sur vos objectifs, votre horizon de temps et votre tolérance au risque." },
      { icon: "Activity", title: "Gestion active du portefeuille", text: "Des placements largement diversifiés entre classes d'actifs – suivis et ajustés en continu." },
      { icon: "UserRound", title: "Accompagnement personnel", text: "Un interlocuteur dédié qui connaît votre situation patrimoniale et reste disponible pour vous." },
      { icon: "Shield", title: "Protection du patrimoine", text: "La préservation du capital et la protection sont au cœur de notre approche – pour vous et la prochaine génération." },
    ],
  },
  advisory: {
    eyebrow: "Conseil patrimonial personnel",
    title: "Un conseiller personnel à vos côtés",
    text: "Plus qu'un dépôt à terme : nos conseillers expérimentés élaborent avec vous une stratégie de placement adaptée à vos objectifs, à votre situation et à votre besoin de sécurité – transparente, indépendante et sans pression commerciale.",
    image: IMG.advisory,
    suitableTitle: "À qui cela s'adresse",
    cta: "Prendre rendez-vous",
    suitable: [
      "Les épargnants souhaitant placer leur patrimoine sur le long terme et en toute sécurité",
      "Les personnes proches ou en retraite recherchant des revenus prévisibles",
      "Les investisseurs qui préfèrent un accompagnement personnel aux applications anonymes",
    ],
    items: [
      { icon: "Target", title: "Stratégie individuelle", text: "Votre placement est adapté à vos objectifs, vos durées et votre tolérance au risque." },
      { icon: "UserRound", title: "Interlocuteur dédié", text: "Un conseiller personnel vous accompagne – accessible, clair et fiable." },
      { icon: "Receipt", title: "Coûts transparents", text: "Des conditions claires sans frais cachés. Vous savez toujours où vous en êtes." },
      { icon: "RefreshCw", title: "Suivi continu", text: "Nous révisons régulièrement votre stratégie et l'ajustons si nécessaire." },
    ],
  },
  process: {
    eyebrow: "Comment se déroule votre conseil",
    title: "Votre stratégie en quatre étapes",
    text: "Simple, sans engagement et à votre rythme.",
    steps: [
      { no: "01", title: "Premier échange", text: "Nous apprenons à vous connaître ainsi que vos objectifs – gratuitement et sans engagement." },
      { no: "02", title: "Analyse", text: "Nous analysons en détail votre situation et votre horizon de placement." },
      { no: "03", title: "Stratégie", text: "Vous recevez une proposition de placement claire et compréhensible." },
      { no: "04", title: "Accompagnement", text: "Nous mettons en œuvre la stratégie et vous accompagnons durablement." },
    ],
    stats: [
      { value: "500+", label: "Clients accompagnés" },
      { value: "15 ans", label: "D'expérience en conseil patrimonial" },
      { value: "100 %", label: "Interlocuteur personnel" },
      { value: "0 €", label: "Coût du premier entretien" },
    ],
  },
  corporate: {
    eyebrow: "Conseil aux entreprises",
    title: "Vos conseillers entreprises personnels",
    text: "Des interlocuteurs dédiés pour le dépôt à terme entreprise – compétents, discrets et toujours disponibles.",
    ctaTitle: "Prêt pour un entretien personnel ?",
    ctaText: "Prenez rendez-vous pour votre entretien gratuit et sans engagement.",
    ctaBtn: "Prendre rendez-vous",
    people: [
      { initials: "LP", name: "Leon Peterson", role: "Conseiller entreprises", region: "Région DACH Allemagne", phone: "+49 30 8268 8142" },
      { initials: "TB", name: "Tanja Berg", role: "Conseillère entreprises", region: "Région DACH Allemagne", phone: "+49 30 8268 5344" },
      { initials: "DW", name: "Dr. Denis Weilandt", role: "Conseiller entreprises", region: "Région DACH Allemagne", phone: "+49 30 8268 6108" },
    ],
  },
  strategies: {
    eyebrow: "Stratégies de placement",
    title: "Trois stratégies pour votre patrimoine.",
    text: "De la préservation du capital à l'orientation croissance – nous trouvons la stratégie adaptée à vos objectifs. Les rendements indiqués sont des valeurs cibles et non une garantie.",
    expectedReturn: "Rendement attendu p.a.",
    risk: "Risque",
    allocation: "Répartition du portefeuille",
    popular: "Populaire",
    cta: "Discuter de la stratégie",
    items: [
      { name: "Conservateur", ret: "2 – 4 %", risk: "Faible", popular: false, text: "Priorité à la préservation du capital : dépôt à terme, obligations de qualité et liquidités. Faible volatilité.", alloc: [{ k: "Dépôt à terme", v: 70 }, { k: "Obligations", v: 25 }, { k: "Actions", v: 5 }] },
      { name: "Équilibré", ret: "4 – 6 %", risk: "Moyen", popular: true, text: "Un mélange équilibré d'obligations et d'actions pour une croissance régulière à risque modéré.", alloc: [{ k: "Dépôt à terme", v: 30 }, { k: "Obligations", v: 35 }, { k: "Actions", v: 35 }] },
      { name: "Croissance", ret: "6 – 9 %", risk: "Élevé", popular: false, text: "Orientation axée sur les actions pour une constitution de patrimoine à long terme – volatilité plus élevée possible.", alloc: [{ k: "Dépôt à terme", v: 10 }, { k: "Obligations", v: 25 }, { k: "Actions", v: 65 }] },
    ],
  },
  steps: {
    title: "Votre dépôt à terme en trois étapes",
    stepWord: "Étape",
    items: [
      { no: "01", title: "Ouvrir un compte", text: "Inscrivez-vous gratuitement et recevez votre compte personnel avec un numéro de référence personnel." },
      { no: "02", title: "Déposer le capital", text: "Virez votre montant de placement sur le compte de conservation indiqué." },
      { no: "03", title: "Placer en dépôt à terme", text: "Choisissez la durée et le montant – votre rendement se met en marche automatiquement." },
    ],
  },
  fees: {
    eyebrow: "Transparence",
    title: "Aperçu des frais",
    note: "Aucun coût caché – une transparence totale.",
    rows: [
      { k: "Ouverture de compte", v: "0 €" },
      { k: "Dépôt", v: "0 €" },
      { k: "Administration / tenue de compte", v: "0 €" },
      { k: "Commission de performance", v: "aucune (uniquement en gestion de patrimoine)" },
      { k: "Versement à l'échéance", v: "0 €" },
      { k: "Autres frais", v: "aucun frais caché" },
    ],
  },
  calculator: {
    title: "Calculateur d'intérêts",
    subtitle: "Calculez votre rendement et voyez comment votre capital croît au fil des années grâce au réinvestissement automatique.",
    amount: "Montant du placement",
    term: "Durée",
    horizon: "Horizon de temps",
    years: "ans",
    ratePa: "Taux annuel",
    interestTerm: "Intérêts (durée)",
    payout: "Versement",
    capitalAfter: "Capital après",
    developmentReinvest: "Évolution avec réinvestissement automatique",
    totalInterest: "Intérêts totaux",
    openAccount: "Ouvrir un compte",
  },
  team: {
    eyebrow: "Notre équipe",
    title: "L'équipe responsable",
    text: "Des responsabilités claires et des interlocuteurs dédiés – pour votre confiance.",
    members: [
      { name: "Francesco Vigna", role: "Direction", img: IMG.team[0], text: "Francesco Vigna est responsable de l'orientation stratégique de Barlow Consultants SL et apporte de nombreuses années d'expérience dans les produits de dépôt à terme et de gestion de patrimoine." },
      { name: "Isabel Moreno", role: "Responsable relation client", img: IMG.team[1], text: "Isabel Moreno est la première interlocutrice de nos clients et veille à un service personnel et transparent à chaque étape du placement." },
      { name: "Henrik Larsson", role: "Responsable stratégie de placement", img: IMG.team[2], text: "Henrik Larsson développe et surveille nos stratégies de placement et veille à un équilibre entre opportunités et risques." },
    ],
  },
  testimonials: {
    eyebrow: "Avis clients",
    title: "Avis clients vérifiés",
    text: "Des expériences réelles de nos clients – identifiées de manière transparente.",
    customerSince: "Client depuis",
    items: [
      { quote: "L'ensemble du processus a été transparent et simple – de l'ouverture du compte au versement ponctuel des intérêts à l'échéance. C'est exactement ce que l'on attend d'un dépôt à terme.", name: "Markus Hoffmann", country: "Allemagne", since: "2025 · vérifié" },
      { quote: "Ce qui m'a convaincu : les frais et les risques sont clairement énoncés, sans petits caractères. Le contact personnel a toujours été compétent et aimable.", name: "Sophie Berger", country: "Luxembourg", since: "2025 · vérifié" },
      { quote: "J'ai comparé plusieurs prestataires. La structure de coûts claire et l'aperçu compréhensible dans l'espace client ont été décisifs.", name: "Daniel Rößler", country: "Autriche", since: "2024 · vérifié" },
      { quote: "Sérieux, compréhensible et fiable. Mes questions ont toujours reçu une réponse rapide et les conditions ont été appliquées exactement comme convenu.", name: "Elena Fischer", country: "Suisse", since: "2025 · vérifié" },
    ],
  },
  contact: {
    eyebrow: "Rendez-vous conseil",
    title: "Prendre un rendez-vous conseil gratuit",
    text: "Laissez-nous vos coordonnées – un conseiller personnel vous recontactera rapidement. Sans engagement et gratuit.",
    perks: ["Stratégie individuelle", "Interlocuteur dédié", "Coûts transparents", "Suivi continu"],
    form: {
      name: "Nom complet",
      email: "Adresse e-mail",
      phone: "Téléphone (facultatif)",
      amount: "Montant de placement envisagé (facultatif)",
      message: "Votre message (facultatif)",
      submit: "Demander un conseil",
    },
    toastErr: "Veuillez indiquer votre nom et votre adresse e-mail.",
    toastOk: "Merci ! Un conseiller vous recontactera rapidement.",
  },
  finalCta: {
    title: "Prêt à faire travailler votre capital ?",
    text: "Ouvrez dès aujourd'hui votre compte de dépôt à terme chez Barlow Consultants SL.",
    button: "Ouvrir un compte",
  },
  cookie: {
    text: "Nous utilisons des cookies nécessaires au fonctionnement du site ainsi que des cookies optionnels pour améliorer votre expérience. Vous décidez de ce que vous autorisez.",
    necessary: "Nécessaires uniquement",
    all: "Tout accepter",
    more: "En savoir plus",
  },
  footer: {
    tagline: "Dépôt à terme & conseil patrimonial avec garantie européenne des dépôts et compte fiduciaire.",
    navTitle: "Navigation",
    legalTitle: "Mentions légales",
    legalLinks: ["Mentions légales", "Confidentialité", "CGV", "Garantie des dépôts", "Cookies"],
    contactTitle: "Contact",
    contactLines: ["Barlow Consultants SL", "Luxembourg"],
    deOfficeTitle: "Bureau Allemagne",
    deOfficeLines: ["Barlow Consultants", "Kurfürstendamm 30", "10719 Berlin", "Allemagne"],
    rights: "Tous droits réservés.",
    disclaimer: "Dépôts protégés jusqu'à 100 000 € conformément à la directive UE 2014/49/UE.",
  },
  accountModal: {
    title: "Ouvrir un compte de dépôt à terme",
    desc: "Gratuit et en quelques minutes – sans aucune paperasse.",
    name: "Nom complet",
    email: "Adresse e-mail",
    amount: "Montant (€)",
    submit: "Ouvrir un compte",
    note: "protégé jusqu'à 100 000 € par le FGDL",
    toastErr: "Veuillez indiquer votre nom et votre adresse e-mail.",
    toastOk: "Demande de compte reçue !",
    errGeneric: "Une erreur est survenue. Veuillez réessayer.",
    successTitle: "Demande de compte reçue !",
    successText: "Merci. Votre demande a été enregistrée.",
    refLabel: "Votre numéro de référence personnel",
    successNote: "Veuillez noter ce numéro de référence. Un conseiller vous contactera sous peu.",
    done: "Terminé",
    copied: "Numéro de référence copié",
  },
  portal: {
    backHome: "Retour au site",
    logout: "Se déconnecter",
    loginTitle: "Bienvenue dans l'espace client",
    loginSubtitle: "Connectez-vous pour consulter votre solde, vos placements et vos prévisions d'intérêts.",
    loginHeadline: "Bon retour",
    loginSub: "Connectez-vous à votre compte.",
    authImageTitle: "Dépôt à terme sûr, au rendement prévisible.",
    authImageSub: "Conservé chez Banking Circle S.A. · Taux fixes jusqu'à 4,25 %",
    emailLabel: "Adresse e-mail",
    passwordLabel: "Mot de passe",
    loginBtn: "Se connecter",
    demoTitle: "Accès démo",
    demoHint: "Pour essayer, utilisez :",
    useDemo: "Remplir les données démo",
    loginErr: "Identifiants invalides. Veuillez utiliser l'accès démo.",
    loginOk: "Connexion réussie.",
    welcome: "Bienvenue,",
    refNo: "Numéro de référence",
    totalBalance: "Capital total",
    investedCapital: "Capital investi",
    projectedInterest: "Intérêts attendus à l'échéance",
    avgRate: "Taux moyen",
    activeDeposits: "Placements à terme en cours",
    colAmount: "Montant du placement",
    colTerm: "Durée",
    colRate: "Taux",
    colMaturity: "Échéance",
    colInterest: "Intérêts gagnés",
    colStatus: "Statut",
    statusActive: "Actif",
    months: "mois",
    forecastTitle: "Prévision d'intérêts",
    forecastNote: "Évolution projetée du capital avec réinvestissement automatique",
    years: "ans",
    afterYears: "Capital après",
    newDeposit: "Ouvrir un nouveau placement",
    registerTitle: "Ouvrir un compte",
    registerSubtitle: "Créez votre compte à terme personnel.",
    depositNote: "jusqu'à 100 000 € protégés",
    accountTypeLabel: "Type de compte",
    accTypePrivate: "Particulier",
    accTypeCompany: "Entreprise",
    nameLabel: "Nom complet",
    countryLabel: "Pays",
    countryPlaceholder: "Sélectionner le pays",
    phoneLabel: "Téléphone",
    consentIntro: "J'accepte les",
    consentTerms: "Conditions d'utilisation",
    consentAgb: "CGV",
    consentMid: "et la",
    consentPrivacy: "Politique de confidentialité",
    errConsent: "Veuillez accepter les CGV et la Politique de confidentialité.",
    registerBtn: "Ouvrir un compte",
    noAccount: "Pas encore de compte ?",
    toRegister: "S'inscrire maintenant",
    haveAccount: "Déjà inscrit ?",
    toLogin: "Se connecter",
    registerOk: "Compte créé avec succès.",
    errEmailExists: "Cette adresse e-mail est déjà enregistrée.",
    errPassword: "Le mot de passe doit comporter au moins 6 caractères.",
    errEmailInvalid: "Veuillez indiquer une adresse e-mail valide.",
    errGeneric: "Une erreur est survenue. Veuillez réessayer.",
    changePwTitle: "Changer le mot de passe",
    changePwSubtitle: "Mettez à jour régulièrement votre mot de passe pour protéger votre compte.",
    currentPwLabel: "Mot de passe actuel",
    newPwLabel: "Nouveau mot de passe",
    confirmPwLabel: "Confirmer le nouveau mot de passe",
    changePwBtn: "Changer le mot de passe",
    changePwOk: "Mot de passe modifié avec succès.",
    errWrongPw: "Le mot de passe actuel est incorrect.",
    errPwMismatch: "Les nouveaux mots de passe ne correspondent pas.",
    errSamePw: "Le nouveau mot de passe doit être différent de l'actuel.",
    forgotPw: "Mot de passe oublié ?",
    forgotTitle: "Réinitialiser le mot de passe",
    forgotSubtitle: "Saisissez votre adresse e-mail et nous vous enverrons un lien de réinitialisation.",
    forgotBtn: "Envoyer le lien",
    forgotOk: "Si un compte existe, nous vous avons envoyé un lien de réinitialisation.",
    backToLogin: "Retour à la connexion",
    resetTitle: "Définir un nouveau mot de passe",
    resetSubtitle: "Choisissez un nouveau mot de passe pour votre compte.",
    resetBtn: "Enregistrer le mot de passe",
    resetOk: "Mot de passe réinitialisé avec succès. Vous pouvez maintenant vous connecter.",
    errInvalidToken: "Ce lien est invalide ou a déjà été utilisé.",
    errExpiredToken: "Ce lien a expiré. Veuillez en demander un nouveau.",
    resetNoToken: "Aucun lien de réinitialisation valide. Veuillez en demander un nouveau.",
    emptyDeposits: "Vous n'avez encore aucun placement à terme. Ouvrez votre premier placement dès maintenant.",
    loading: "Chargement …",
    sbOverview: "Aperçu",
    sbFestgeld: "Dépôt à terme",
    sbTransactions: "Transactions",
    sbDocuments: "Documents",
    sbForecast: "Prévision",
    sbStrategy: "Stratégie de placement",
    sbSecurity: "Sécurité",
    availableBalance: "Solde disponible",
    accountNumber: "Numéro de compte",
    statusLabel: "Statut",
    deposit: "Déposer de l'argent",
    requestWithdrawal: "Demander un retrait",
    statementPdf: "Relevé (PDF)",
    securityBanner: "protégé jusqu'à 100 000 € par déposant. Conservé auprès d'une banque partenaire réglementée au Luxembourg · Protégé selon la directive UE 2014/49/UE.",
    securityBannerBold: "protégé jusqu'à 100 000 € par déposant.",
    securityBannerText: "Accès à plus de 50 banques européennes – plus des banques leaders au Royaume-Uni · Protégé selon la directive UE 2014/49/UE",
    securityBannerLink: "En savoir plus sur la garantie des dépôts",
    securityBannerExtra: "En complément, vos dépôts sont conservés à titre fiduciaire sur un compte fiduciaire.",
    depositTitle: "Déposer de l'argent",
    withdrawTitle: "Demander un retrait",
    investTitle: "Placer en dépôt à terme",
    amountLabel: "Montant (€)",
    termLabel: "Durée",
    confirm: "Confirmer",
    cancel: "Annuler",
    depositOk: "Dépôt crédité avec succès.",
    withdrawOk: "Retrait demandé.",
    investOk: "Dépôt à terme créé avec succès.",
    insufficient: "Solde disponible insuffisant.",
    invalidAmount: "Veuillez saisir un montant valide.",
    noTransactions: "Aucune transaction pour le moment.",
    txDeposit: "Dépôt",
    txWithdrawal: "Retrait",
    txInvest: "Placement à terme",
    colDate: "Date",
    colType: "Opération",
    statusCompleted: "Terminé",
    statusPending: "En cours",
    documentsTitle: "Documents",
    documentsDesc: "Téléchargez votre relevé de compte actuel au format PDF.",
    invest: "Placer",
    statementHeading: "Relevé de compte",
    generatedOn: "Généré le",
  },
  chat: {
    title: "Assistant Barlow",
    subtitle: "Questions sur le dépôt à terme, la sécurité & les frais",
    greeting: "Bonjour ! Je réponds volontiers à vos questions sur nos offres de dépôt à terme, la garantie des dépôts et les frais. Comment puis-je aider ?",
    faqLabel: "Questions fréquentes",
    faqs: ["Mon argent est-il en sécurité ?", "Quels taux proposez-vous ?", "Quels frais s'appliquent ?", "Comment ouvrir un compte ?"],
    placeholder: "Écrire un message …",
    error: "Désolé, un problème est survenu. Veuillez réessayer plus tard.",
    open: "Ouvrir le chat",
    close: "Fermer",
  },
};

export default fr;
